// This file is generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */

/**
 * Describes the various content types 
 */
export enum AbstractDocumentKind {

    /**
     * Issue Brief
     */
    IssueBrief = 'Issue Briefs',

    /**
     * Profile of an MP
     */
    ProfileOfMP = 'MP Profiles',

    /**
     * Frequently asked question
     */
    FAQ = 'Frequently Asked Questions',

    /**
     * Media lines
     */
    MediaLines = 'Media Lines',

    /**
     * Person
     */
    Person = 'People',

    /**
     * Debate notes (larger detailed information)
     */
    DebateNotes = 'Debate Notes',

    /**
     * Op Ed
     */
    OpinionEditorial = 'Opinion Editorials',

    /**
     * Quote
     */
    Quote = 'Quotes',

    /**
     * Achievement
     */
    Achievement = 'Achievements',

    /**
     * Resources
     */
    Resource = 'Resources'
}


// WEBPACK FOOTER //
// ./src/model/autogen/AbstractDocumentKind.ts